export default "__VITE_ASSET__6F$FgJmv__"